<template>
  <!--
    	作者：wangjie
    	时间：2023-09-21
    	描述：菜品管理-菜品编辑-菜品同步
    -->
  <div class="buy-set-content pl16 pr16">
    <!--积分设置-->
    <div class="common-form">{{$t('菜品同步')}}</div>
    <el-form-item :label="processedData">
      <el-radio-group v-model="form.sync">
        <el-radio :label="1">{{$t('是')}}</el-radio>
        <el-radio :label="0">{{$t('否')}}</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
  export default {
    data() {
      return {};
    },
    props: ['part'],
    computed: {
      processedData() {
        // 在这里根据父组件传递的值做出处理
        if (this.part === 'shop') {
          return this.$t('是否同步菜品至外卖') ;
        } else {
          return this.$t('是否同步菜品至店内');
        }
      }
    },
    inject: ['form'],
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/takeaway/product/part/Sync.vue